/**
 * Chromspec Redirect Popup
 * Detects ?chromspec URL parameter and shows popup notification
 */

class ChromspecPopup {
  constructor() {
    this.popupId = 'chromspec-popup';
    this.sessionKey = 'chromspec_popup_shown';
    this.init();
  }

  init() {
    // Check if URL contains chromspec parameter
    const urlParams = new URLSearchParams(window.location.search);
    const hasChromspec = urlParams.has('chromspec');

    if (hasChromspec) {
      this.showPopup();
    }
  }

  showPopup() {
    const popup = document.getElementById(this.popupId);
    const overlay = document.querySelector('.chromspec-popup__overlay');
    
    if (popup && overlay) {
      // Add visible class to trigger animation
      setTimeout(() => {
        popup.classList.add('visible');
        overlay.classList.add('visible');
        // Prevent body scroll when popup is open
        document.body.style.overflow = 'hidden';
      }, 300);
    }
  }

  closePopup() {
    const popup = document.getElementById(this.popupId);
    const overlay = document.querySelector('.chromspec-popup__overlay');
    
    if (popup && overlay) {
      popup.classList.remove('visible');
      overlay.classList.remove('visible');
      // Restore body scroll
      document.body.style.overflow = '';
      
      setTimeout(() => {
        popup.style.display = 'none';
      }, 300);
      
      // Remove chromspec parameter from URL
      this.removeChromspecParam();
    }
  }

  removeChromspecParam() {
    // Get current URL
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    
    // Remove the chromspec parameter if it exists
    if (params.has('chromspec')) {
      params.delete('chromspec');
      
      // Build new URL without the parameter
      const newSearch = params.toString();
      const newUrl = url.pathname + (newSearch ? '?' + newSearch : '') + url.hash;
      
      // Update URL without reloading the page
      window.history.replaceState({}, '', newUrl);
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.chromspecPopup = new ChromspecPopup();
  });
} else {
  window.chromspecPopup = new ChromspecPopup();
}

// Handle close button clicks
document.addEventListener('click', (e) => {
  if (e.target.closest('.chromspec-popup__close')) {
    if (window.chromspecPopup) {
      window.chromspecPopup.closePopup();
    }
  }
});

// Handle overlay clicks
document.addEventListener('click', (e) => {
  if (e.target.classList.contains('chromspec-popup__overlay')) {
    if (window.chromspecPopup) {
      window.chromspecPopup.closePopup();
    }
  }
});
